import { Control } from "react-hook-form";

import { DateRange } from "components/form_components/Inputs";
import { DocumentFilters } from "../utils";

import css from "./SharedFilterGroups.module.scss";

export interface PublishedDateFilterContentProps {
  control: Control<DocumentFilters, unknown>;
}

function PublishedDateFilterContent({ control }: PublishedDateFilterContentProps) {
  return (
    <div className={css.filterSection} aria-label="Published date filters">
      <DateRange
        name="publishDate.filter"
        control={control}
        label="Published date"
        showFutureDates={false}
      />
    </div>
  );
}

export default PublishedDateFilterContent;
